import { ImportState, LotChanges } from 'types';
import { hasEmptyNewLot } from '@components/bid_request/details/utils';

/**
 * Check if empty lots should be removed on upload
 *
 * @param importState {ImportState}
 * @param changes {Record<string, LotChanges>}
 */
export const shouldRemoveEmptyLotsOnImport = (
  importState: ImportState,
  changes: Record<string, LotChanges>
): boolean => {
  return (importState.status.uploadStartedFromNewEvent || importState.status.uploadStartedFromEmptyLot) && hasEmptyNewLot(changes);
};
